import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const mainLayout = document.getElementById('main-layout');

    if (mainLayout) {
      mainLayout.style.scrollBehavior = 'auto';
      mainLayout.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
